module.exports = __webpack_public_path__ + "static/media/alter_shape_passo3.2402229e.png";